export enum AppContext {
    Tableau = 'tableau',
    Stock = 'stock',
    Waste = 'waste',
    Foundation = 'foundation'
}
